import { createMuiTheme } from "@material-ui/core";

// tasteck ブランドカラー (キャストモバイル向け、目に優しい調整版)
//
// 基本方針:
// - キャストは夜間 + 接客前/合間 + メモ記入で長時間使う → 明度・彩度を抑える
// - primary: 深い teal (staff-app と統一)
// - secondary: 警告/削除用の赤
// - 背景は純白ではなく cool グレー (目の負担軽減)
const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#0d9488",
      main: "#115e59",
      dark: "#0f4945",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#fca5a5",
      main: "#dc2626",
      dark: "#b91c1c",
      contrastText: "#ffffff",
    },
    error: {
      main: "#dc2626",
    },
    warning: {
      main: "#d97706",
    },
    success: {
      main: "#15803d",
    },
    info: {
      main: "#0d9488",
    },
    text: {
      primary: "#1a2332",
      secondary: "#5e6a7c",
    },
    background: {
      default: "#f3f5f7",
      paper: "#fbfcfd",
    },
    divider: "rgba(0, 0, 0, 0.08)",
  },
  typography: {
    htmlFontSize: 10,
    fontSize: 14,
    body1: {
      fontSize: "1.4rem",
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 479,
      md: 768,
      lg: 959,
      xl: 1112,
    },
  },
});

export default theme;
